'use client'

import {
  ComboboxItem,
  OptionsFilter,
  Select,
  Group,
  Image,
  Text,
  Loader
} from '@mantine/core'
import { FaCheck } from 'react-icons/fa6'
import NextImage from 'next/image'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

const normalizeText = (text) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()

const optionsFilter: OptionsFilter = ({ options, search }) => {
  const searchWords = normalizeText(search).split(' ')
  return (options as ComboboxItem[]).filter((option) => {
    const optionWords = normalizeText(option.label).split(' ')
    return searchWords.every((word) =>
      optionWords.some((optWord) => optWord.includes(word))
    )
  })
}

export default function LocalSelect({
  options = [],
  placeholder,
  defaultValue = '',
  url,
  lang = 'en',
  locale
}) {
  const localizedPlaceholder = locale?.components?.localSelect?.placeholder
  const router = useRouter()
  const renderSelectOption = ({ option, checked }) => (
    <Group flex="1" gap="xs" wrap="nowrap">
      <Image
        component={NextImage}
        quality={60}
        src={option.image}
        alt={option.label}
        width={132}
        height={99}
        h={15}
        w={20}
        style={{
          boxShadow: '0px 0px 1px 0px gray'
        }}
      />
      <Text> {option.label} </Text>
      {checked && (
        <FaCheck
          size={16}
          style={{ marginInlineStart: 'auto' }}
          {...{
            stroke: '1.5',
            color: 'currentColor',
            opacity: 0.6,
            size: 18
          }}
        />
      )}
    </Group>
  )

  const selectedCountry = options.find(
    (option) => option.value === defaultValue
  )

  const [isLoading, setIsLoading] = useState(false)

  const handleSelect = (selected: string) => {
    setIsLoading(true)
    router.push(`/${url}/${selected}`)
  }

  const leftSection = () => {
    if (isLoading) {
      return <Loader size="xs" />
    }
    return selectedCountry ? (
      <Image
        src={selectedCountry?.image}
        alt={selectedCountry?.label}
        width={132}
        height={99}
        component={NextImage}
        quality={60}
        h={15}
        w={20}
        style={{
          boxShadow: '0px 0px 1px 0px gray'
        }}
      />
    ) : null
  }

  return (
    <Select
      styles={{
        input: {
          backgroundColor: '#ffffff'
        }
      }}
      leftSection={leftSection()}
      w={{
        base: 280,
        xs: 350
      }}
      size={'sm'}
      allowDeselect={false}
      searchable
      placeholder={localizedPlaceholder}
      data={options}
      onChange={handleSelect}
      value={defaultValue}
      renderOption={renderSelectOption}
      filter={optionsFilter}
    />
  )
}
